import { FormattedMessage } from "react-intl";
import "./Footer.scss";

const menuItems = [
  {
    link: "https://synergysports.com/contact/",
    intlKey: "contact",
  },
  {
    link: "https://synergyautomatedcamerasystem.zendesk.com/hc/en-us/sections/4414390198029-Synergy-Competition-Admin-User-Guide",
    intlKey: "support",
  },
  {
    link: "https://sportradar.com/single-sign-on-sso-privacy-notice/",
    intlKey: "privacy",
  },
  {
    link: "https://synergysports.com/terms-of-use/",
    intlKey: "terms",
  },
];

export const Footer = () => {
  const date = new Date();
  const year = date.getFullYear();

  return (
    <div className="app-footer">
      <span className="copyright">&copy; {year} - Sportradar</span>
      {menuItems.map(({ link, intlKey }) => (
        <a key={link} href={link} target="_blank" rel="noreferrer">
          <FormattedMessage id={intlKey} />
        </a>
      ))}
    </div>
  );
};
